
import React, { useState, useEffect, forwardRef } from 'react';
import ReactDOM from 'react-dom';

interface DropdownPortalProps {
  children: React.ReactNode;
  isOpen: boolean;
  targetRef: React.RefObject<HTMLElement>;
}

export const DropdownPortal = forwardRef<HTMLDivElement, DropdownPortalProps>(
  ({ children, isOpen, targetRef }, ref) => {
    const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });

    useEffect(() => {
      if (isOpen && targetRef.current) {
        const rect = targetRef.current.getBoundingClientRect();
        setPosition({
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
          width: rect.width
        });
      }
    }, [isOpen, targetRef]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
      <div 
        ref={ref}
        style={{
          position: 'absolute',
          top: position.top,
          left: position.left,
          width: position.width,
          zIndex: 99999,
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '6px',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
          maxHeight: '240px',
          overflowY: 'auto',
          marginTop: '4px'
        }}
      >
        {children}
      </div>,
      document.body
    );
  }
);

DropdownPortal.displayName = 'DropdownPortal';
